import React from "react";
import { Link } from "react-router-dom";
import PageShell from "@/components/PageShell";
import { CompassMark } from "@/components/CompassMark";

export default function NotFound() {
  return (
    <PageShell testId="page-404" title="Off the map | Quentin Young" description="This page is off the map. Return to the compass and explore the archive." noindex>
      <section className="container-edge py-24 md:py-40 min-h-[60vh] flex items-center">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center w-full">
          <div className="lg:col-span-7">
            <p className="eyebrow-gold mb-5">404 · Off the map</p>
            <h1 className="display-serif text-5xl md:text-7xl lg:text-8xl text-paper-primary text-balance leading-[1.02]">
              Distance distorts reality.
            </h1>
            <p className="mt-8 max-w-xl font-serif text-lg md:text-xl text-paper-secondary leading-relaxed text-pretty">
              The page you tried to reach is either retired, renamed, or never earned permanence. Use the compass.
            </p>
            <div className="mt-10 flex flex-wrap gap-5">
              <Link to="/" className="btn-arrow" data-testid="nf-home">
                <span>Return home</span>
                <span className="arrow">→</span>
              </Link>
              <Link to="/thinking" className="btn-quiet" data-testid="nf-thinking">
                <span>Read the archive</span>
              </Link>
            </div>
          </div>
          <div className="lg:col-span-5 flex justify-center lg:justify-end">
            <CompassMark size={320} opacity={0.3} className="grayscale" />
          </div>
        </div>
      </section>
    </PageShell>
  );
}
